import React, { useState } from 'react'
import { FaHeart, FaStar } from 'react-icons/fa'
import { CiLocationOn } from 'react-icons/ci'
import { Hall, Stay } from '../../types'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { PiHeartFill } from 'react-icons/pi'
import Cookies from 'js-cookie'
import { useDispatch } from 'react-redux'
import { addFavorite, fetchFavorites, deleteFavorite } from '../../features/home/favSlice'
import { AppDispatch } from '../../store'
import toast from 'react-hot-toast'

const PlaceCard = ({ place }: { place: Stay | Hall }) => {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch<AppDispatch>();

    const userId = Cookies.get('userId');

    const [isFavorite, setIsFavorite] = useState(place.isFavorite);

    const handleAddToFavorite = async () => {
        if (!userId) return toast.error(t("please-login-first"));

        setIsFavorite(true);
        await dispatch(addFavorite({
            itemId: place.id,
            userId,
            type: "Place",
        }));
        dispatch(fetchFavorites({ id: userId }));
    };

    const handleRemoveFromFavorite = async () => {
        if (!userId) return;
        setIsFavorite(false);
        await dispatch(deleteFavorite({
            itemId: place.id,
            userId,
            type: "Place"
        }));
        dispatch(fetchFavorites({ id: userId }));
    };

    return (
        <Link to={`/place/${place.id}`} className="flex w-full overflow-hidden rounded-2xl bg-white shadow-sm">
            <div className="sm:w-48 xs:w-32 overflow-hidden relative">
                <img
                    src={place.images[0]
                        ? place.images[0]?.url
                        : "/asset/modern-commercial-building.webp"}
                    alt={place.title}
                    className="w-full h-full object-cover"
                />
                <span className={`absolute top-3 ${i18n.language === "ar" ? "right-3" : "left-3"} rounded-md bg-primary px-3 py-1 text-sm text-white`}>
                    {place.subCategory?.title || place.type}
                </span>
            </div>

            <div className="flex flex-col justify-between flex-1 p-3">
                <div className="flex items-start justify-between">
                    <div className="flex items-center gap-2 text-sm text-gray-600 mt-2">
                        <FaStar className="text-secondry" />
                        {place.rate.toFixed(1)} <span className="text-gray-400">({place.reviews?.length} {t("reviews")})</span>
                    </div>

                    {isFavorite ? (
                        <button
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleRemoveFromFavorite();
                            }}
                            className="text-red-600 hover:text-red-500 bg-white rounded-full shadow-md p-2 text-xl"
                        >
                            <PiHeartFill />
                        </button>
                    ) : (
                        <button
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleAddToFavorite();
                            }}
                            className="text-textSecond hover:text-red-500 bg-white rounded-full shadow-md p-2 text-xl"
                        >
                            <FaHeart />
                        </button>
                    )}
                </div>

                {/* Title */}
                <h2 className="text-xl font-bold">{place.title}</h2>

                {/* layout */}
                {place?.type === "Stay" && place.subCategory.id !== 1 &&
                    <div className=" flex gap-2 text-blue-700  ">
                        {place?.numberOfRooms && place?.numberOfRooms > 0 &&
                            <p>
                                {place?.numberOfRooms === 1 ? t("a-room") : place?.numberOfRooms === 2 ? t("2-room") : place?.numberOfRooms + " " + t("a-rooms")}
                            </p>
                        }
                        {place?.numberOfHalls && place?.numberOfHalls > 0 ?
                            <p>
                                + {place?.numberOfHalls} {t("palce-Hall")}
                            </p> : <p>{t("without-placeHall")}</p>
                        }
                    </div>
                }

                {/* Location */}
                <p className="text-sm text-gray-500 flex items-center gap-1">
                    <CiLocationOn /> {place.location}
                </p>

                {/* Amenities + Price */}
                <div className='grid xs:grid-cols-1 sm:grid-cols-4 w-full justify-between'>
                    <div className="col-span-3 flex flex-wrap gap-3 text-sm text-gray-600 mt-3">
                        {place.amenities?.map((service, index) => (
                            <span key={index} className="flex items-center gap-1 whitespace-nowrap">
                                <div className='w-4'>
                                    <img src={service.image} className='w-full' alt='service-image' />
                                </div>
                                {service.title}
                            </span>
                        ))}
                    </div>

                    {/* Price */}
                    <div className="text-right flex justify-end mt-auto flex-nowrap items-baseline gap-1">
                        <span className="text-lg text-nowrap font-bold text-secondry">
                            {place && place.discountPercentage > 0 ? (
                                <div className="flex flex-col w-full items-baseline text-center gap-2">
                                    <p className="line-through text-red-600 text-sm">
                                        {place.price.toFixed(2)} {place?.currencyCode}
                                        <span className="text-sm text-nowrap ml-1">{place.type === "Hall" ? t("per-morning") : t("per-night")}</span>
                                    </p>
                                    <p className="text-secondry font-bold text-xl">
                                        {(place?.price - (place.price * place?.discountPercentage) / 100).toFixed(2)} {place?.currencyCode}
                                        <span className="text-sm text-nowrap ml-1">{place.type === "Hall" ? t("per-morning") : t("per-night")}</span>
                                    </p>
                                </div>
                            ) : (
                                <p className="font-semibold">
                                    {place?.price.toFixed(2)} {place?.currencyCode}
                                    <span className="text-sm text-nowrap ml-1">{place.type === "Hall" ? t("per-morning") : t("per-night")}</span>
                                </p>
                            )}
                        </span>
                    </div>
                </div>
            </div>
        </Link>
    )
}

export default PlaceCard
